module.exports = __webpack_public_path__ + "img/p5.331c5960.png";